import { PluginsGroupsTab } from "./PluginsGroupsTab";

export default PluginsGroupsTab;
